import {Box, ListItem} from '@mui/material';
import styled from 'styled-components';

const FilledCircle = styled(Box)`
	width: ${({theme}) => theme.spacing(1)};
	height: ${({theme}) => theme.spacing(1)};
	border-radius: ${({theme}) => theme.spacing(0.5)};
`;

const StyledListItem = styled(ListItem)`
	padding-top: ${({theme}) => theme.spacing(0.5)};
	padding-bottom: ${({theme}) => theme.spacing(0.5)};
	padding-left: 0;
	padding-right: 0;
`;

export {FilledCircle, StyledListItem};
